import { ServiceTemplateDetailsState } from "@idw-types/state/service-template-details-state";
import { ServiceTemplateDetailsActions, ServiceTemplateDetailsActionTypes } from "@redux/actions/service-template-details-actions";

export const initialServiceTemplateDetailsState: ServiceTemplateDetailsState = {
    data: {
        isLoading: false,
        serviceTemplate: null
    }
};

export const serviceTemplateDetailsReducer = (
    state: ServiceTemplateDetailsState = initialServiceTemplateDetailsState,
    action: ServiceTemplateDetailsActions
): ServiceTemplateDetailsState => {
    switch (action.type) {
        case ServiceTemplateDetailsActionTypes.SET_SERVICE_TEMPLATE_DETAILS_LOADING:
            return {
                ...state,
                data: {
                    ...(action.payload.isLoading
                        ? { ...initialServiceTemplateDetailsState.data }
                        : { ...state.data }),
                    isLoading: action.payload.isLoading
                }
            };
        case ServiceTemplateDetailsActionTypes.SET_SERVICE_TEMPLATE_DETAILS:
            return {
                ...state,
                data: {
                    serviceTemplate: action.payload.serviceTemplate,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};